"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _reactIntl = require("react-intl");

var _reactComponents = require("@cimpress/react-components");

var _ListPriceInitiatorWizardModal = require("./ListPriceInitiatorWizardModal");

var _shapes = _interopRequireDefault(require("./shapes"));

var _ContractSelector = _interopRequireDefault(require("../ContractSelector/ContractSelector"));

var _listPriceInitiatorMessages = require("./listPriceInitiatorMessages");

var defaultState = {
  loading: true
};

var ListPriceCreateStep =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListPriceCreateStep, _React$Component);

  function ListPriceCreateStep(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ListPriceCreateStep);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListPriceCreateStep).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = (0, _objectSpread2.default)({}, defaultState);
    return _this;
  }

  (0, _createClass2.default)(ListPriceCreateStep, [{
    key: "onChangeNewContractName",
    value: function () {
      var _onChangeNewContractName = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(e) {
        var onChangeNewContractName;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onChangeNewContractName = this.props.onChangeNewContractName;
                onChangeNewContractName && onChangeNewContractName(e.target.value);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onChangeNewContractName(_x) {
        return _onChangeNewContractName.apply(this, arguments);
      }

      return onChangeNewContractName;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          createOption = _this$props.createOption,
          newContractName = _this$props.newContractName,
          selectedListPriceContract = _this$props.selectedListPriceContract,
          listPrices = _this$props.listPrices,
          productFulfiller = _this$props.productFulfiller,
          onSelectListPriceContract = _this$props.onSelectListPriceContract,
          _this$props$intl = _this$props.intl,
          formatMessage = _this$props$intl.formatMessage,
          locale = _this$props$intl.locale;
      return createOption === _ListPriceInitiatorWizardModal.EXISTING ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h5", null, formatMessage(_listPriceInitiatorMessages.listPriceCreateStep.existingHeader, {
        name: productFulfiller.name
      })), _react.default.createElement(_ContractSelector.default, {
        locale: locale,
        contracts: listPrices,
        selectedContract: selectedListPriceContract,
        onSelect: onSelectListPriceContract
      })) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h5", null, formatMessage(_listPriceInitiatorMessages.listPriceCreateStep.newHeader)), _react.default.createElement(_reactComponents.TextField, {
        value: newContractName,
        placeholder: formatMessage(_listPriceInitiatorMessages.listPriceCreateStep.contractNamePlaceholder, {
          name: productFulfiller.name
        }),
        onChange: this.onChangeNewContractName
      }));
    }
  }]);
  return ListPriceCreateStep;
}(_react.default.Component);

var _default = (0, _reactIntl.injectIntl)(ListPriceCreateStep);

exports.default = _default;